import { Button } from "@mui/material";
import { PaymentResponseType } from "../../types/General";
import Chip from "../../components/Chip";

type props = {
  type: any;
  data?: PaymentResponseType | null;
  changePaymentStatus: (id: any) => void;
};

const PaymentDetailTop = ({ data, changePaymentStatus }: props) => {
  return (
    <>
      <div className="cards profile_top">
        <div className="gap_p">
          <div className="left_s">
            <div className="profile_image">
              <figure>
                <img
                  src={
                    data?.user?.profile_picture?.media_url ||
                    "/static/images/user_placeholder.png"
                  }
                  alt="Profile"
                />
                <span>
                  <img src="/static/images/verified_icon.svg" alt="Icon" />
                </span>
              </figure>
              <p> {data?.application?.apk_id || ""}</p>
            </div>
            <div className="profile_info">
              <h2>
                <b>{`${data?.user?.name} `}</b>
              </h2>

              <ul className="text_list">
                <li>
                  <img src="/static/images/sms_icon.svg" alt="Icon" />{" "}
                  {data?.user?.email ? (
                    <a
                      href={`mailto:${data?.user?.email}`}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {data?.user?.email}
                    </a>
                  ) : (
                    "-"
                  )}
                </li>
                {data?.user?.phone_no ? (
                  <li>
                    <img src="/static/images/calling_icon.svg" alt="Icon" />

                    {data?.user?.phone_no ? (
                      <a
                        href={`tel:${data?.user?.country_code}${data?.user?.phone_no}`}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {data?.user?.country_code} {data?.user?.phone_no}
                      </a>
                    ) : (
                      "-"
                    )}
                  </li>
                ) : null}
              </ul>
              {data?.plan_mode?.id === 1 || data?.plan_mode?.id === 2 ? (
                <div style={{ display: "flex", gap: "20px" }}>
                  {data?.is_verified ? (
                    <Chip
                      label={"Approved"}
                      color={"#4CAF50"}
                      backgroundColor={"#E8F5E9"}
                    />
                  ) : (
                    <Button
                      className="btn btn_blue"
                      onClick={() => changePaymentStatus(data?.id)}
                      style={{ height: "30px", padding: "5px 12px" }}
                    >
                      Approve
                    </Button>
                  )}
                  {data?.payment_slip_partner?.length ? (
                    <div>
                      <Button
                        className="btn btn_blue"
                        onClick={() =>
                          window?.open(
                            data?.payment_slip_partner?.[0]?.media_url
                          )
                        }
                        style={{ height: "30px", padding: "5px 12px" }}
                      >
                        View Receipt
                      </Button>
                    </div>
                  ) : null}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentDetailTop;
